<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      dark
      src="@/assets/img/bgDrawer.jpg"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img src="@/assets/img/logo_dwhtest_wheel.png" alt="Logo" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">DWH Test</v-list-item-title>
            <v-list-item-subtitle>Regression</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          @click="$vuetify.goTo(link)"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
              text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      class="px-15"
      :class="{ expand: flat }"
    >
      <v-toolbar-title>
        <v-img src="@/assets/img/logo_dwhtest_regression.png" max-width="150px" />
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
      />
      <div v-else>
        <v-btn text @click="$vuetify.goTo('#hero')">
          <span class="mr-2">Home</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#features')">
          <span class="mr-2">Features</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#pricing')">
          <span class="mr-2">Editions</span>
        </v-btn>                
        <v-btn text @click="$vuetify.goTo('#download')">
          <span class="mr-2">Download</span>
        </v-btn>
        <v-btn  text @click="$vuetify.goTo('#contact')">
          <span class="mr-2">Contact us</span>
        </v-btn>

        <loginMenu v-if="!user" :loading="loading"/>
        <userMenu v-if="user"/>
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}
</style>

<script>
import userMenu from './userMenu';
import loginMenu from './loginMenu';
import {get,sync} from 'vuex-pathify'

export default {
  components: {userMenu, loginMenu},
  data: () => ({
    drawer: null,
    loading: true,
    isXs: false,
    items: [
      ["mdi-home-outline", "Home", "#hero"],
      ["mdi-download-box-outline", "Download", "#download"],
      ["mdi-information-outline", "Features", "#features"],
      ["mdi-currency-usd", "Documentation", "#pricing"],
      ["mdi-email-outline", "Contacts", "#contact"],
    ],
  }),
  computed: {
    user: sync("user"),
  },
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
    async login(){
      let store = this.$store
      this.$firebase.auth().onAuthStateChanged(async (user) => {
        if (user) {
          await store.dispatch("retrieveUser")
          await this.$store.dispatch("getOrganisation")
        } else {
          let logout = await this.$firebase.auth().signOut()
          this.user = null
        }
        this.loading = false;
      });
      this.$firebase.auth().onIdTokenChanged(async user => {
        if (user) {
          await store.dispatch("retrieveUser")
        }
      })
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  async created() {
    this.$axios.defaults.baseURL = process.env.VUE_APP_BACKEND;
    await this.login()
  },
};
</script>
